import React from 'react';
import { Page } from '../components/Page/Page';

export const NoMatchPage = () => {
	return (
		<Page title="No Match Page">
			<p>Page not found</p>
		</Page>
	);
};
